import { Entity, Index, PrimaryColumn, Column, BaseEntity } from "typeorm";

@Entity({ name: 'booking_order_items' })
@Index(['business_id', 'location_id', 'id'])
@Index(['business_id', 'location_id', 'last_modified'])
@Index(['business_id', 'location_id', 'isSynced'])
@Index(['business_id', 'location_id', 'booking_order_id', 'last_modified'])
export class BookingOrderItem extends BaseEntity {
  @PrimaryColumn()
  id: string;

  @Column()
  @Index()
  business_id: string;

  @Column() 
  @Index()
  location_id: string;

  @Column()
  @Index()
  booking_order_id: string;

  @Column()
  @Index()
  inventory_item_id: string;

  @Column({ type: 'float', precision: 19, scale: 4, default: 0 })
  quantity: number;

  @Column({ type: 'decimal', precision: 26, scale: 8, default: 0.0 })
  price: string;

  @Column({ type: 'text', nullable: true })
  metadata: string;

  @Column()
  created_at: Date;

  @Column({ nullable: true })
  updated_at: Date;

  @Column({ type: 'bigint', nullable: true })
  @Index()
  last_modified: number;

  @Column({ default: false })
  @Index()
  isSynced: boolean;
}